import { z } from "zod/v4";

export const DiscountTierDtoSchema = z.object({
  id: z.uuid(),
  minimumUnits: z.number().default(1),
  maximumUnits: z.number().default(1),
  unitDiscount: z.number().default(1),
  discountTitle: z.string().nullable().default(null),
  giftWithPurchaseTitle: z.string().nullable().default(null),
  isFreeShipping: z.boolean().default(false),
  isGiftWithPurchase: z.boolean().default(false),
  giftWithPurchaseProductId: z.string().nullish(),
  giftWithPurchaseVariantId: z.string().nullish(),
  autoAddGiftWithPurchase: z.boolean().default(false),
  giftWithPurchaseHandle: z.string().nullish(),
});

export type DiscountTierDto = z.infer<typeof DiscountTierDtoSchema>;
